module.exports = __webpack_public_path__ + "static/media/gpxcarbo_small.3edbee35.jpg";